import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { progress as progressApi } from '../api';
import './Progress.css';

const Progress = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    progressApi.get(id).then(setData);
  }, [id]);

  if (!data) return <div className="loading">Loading...</div>;

  const coverage = Math.round((data.studiedCards / data.totalCards) * 100);
  const avg = parseFloat(data.averageRating) || 0;
  const readiness = data.studiedCards && avg ? Math.round(coverage * Math.max(0, (avg - 1) / 4) / 100 * 100) : 0;
  const readinessColor = readiness >= 80 ? '#22c55e' : readiness >= 60 ? '#eab308' : '#ef4444';

  return (
    <div className="progress-page">
      <nav className="nav">
        <div className="nav-content">
          <Link to="/" className="logo">C3</Link>
          <Link to="/dashboard" className="btn-secondary">Dashboard</Link>
        </div>
      </nav>

      <div className="progress-container">
        <h1>Progress Report</h1>

        <div className="stats-grid">
          <div className="stat-card"><div className="stat-value">{data.studiedCards} / {data.totalCards}</div><div className="stat-label">Cards Studied</div></div>
          <div className="stat-card"><div className="stat-value">{avg}/5</div><div className="stat-label">Avg Rating</div></div>
          <div className="stat-card"><div className="stat-value" style={{ color: readinessColor }}>{readiness}%</div><div className="stat-label">Exam Ready</div></div>
        </div>

        <div className="domain-progress">
          <h2>Domain Breakdown</h2>
          {data.domainProgress.map((stat, i) => {
            const dAvg = parseFloat(stat.avgRating) || 0;
            const dReadiness = stat.studied && dAvg ? Math.round((stat.studied / stat.total) * Math.max(0, (dAvg - 1) / 4) * 100) : 0;
            return (
              <div key={i} className="domain-stat">
                <div className="domain-header">
                  <span className="domain-name">{stat.domain}</span>
                  <span className="domain-count">{stat.studied}/{stat.total} · {dAvg}/5 · {dReadiness}% ready</span>
                </div>
                <div className="domain-bar">
                  <div className="domain-fill" style={{ width: `${dReadiness}%` }} />
                </div>
                <div className="domain-actions">
                  {[5, 10].map(n => (
                    <Link key={n} to={`/study/${id}?size=${n}&domain=${encodeURIComponent(stat.domain)}`} className="btn-primary btn-sm">Study {n}</Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="collection-actions">
          {[5, 10, 15].map(n => (
            <Link key={n} to={`/study/${id}?size=${n}`} className="btn-primary btn-sm">Study {n}</Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Progress;
